/* tslint:disable */
/* eslint-disable */
/**
 * B2B Card
 * APIs for using and interacting with credit cards  # Tracking Metrics * `b2bportal.booking.payment.error`   * tags: `api_version`, `error_code`, `payment`, `tenantid` * `b2bportal.card.delete.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.card.delete.success`   * tags: `api_version`, `tenantid` * `b2bportal.card.get.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.card.get.success`   * tags: `api_version`, `tenantid` * `b2bportal.card.list.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.card.list.success`   * tags: `api_version`, `tenantid` * `b2bportal.card.verify.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.card.verify.success`   * tags: `api_version`, `tenantid` * `b2bportal.quote.payment.error`   * tags: `api_version`, `error_code`, `payment`, `quote_action`, `tenantid`   # Tracking Error Codes * `authorize_failure` * `bad_request` * `capture_failure` * `card_declined` * `create_payment_failed` * `excessive_user_activity` * `expired_card` * `generic_error` * `inactive_card` * `internal_error` * `invalid_address` * `invalid_currency` * `invalid_cvv` * `limit_exceeded` * `negative_payment_amount` * `not_enough_balance` * `payment_not_found` * `refund_failure` * `request_deserialization_error` * `response_serialization_error` * `service_error` * `unknown_card` * `unknown`  
 *
 * The version of the OpenAPI document: v0p33
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: AxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}
